module.exports = __webpack_public_path__ + "img/background.ba1ba113.svg";